/**
 * @generated SignedSource<<0488f1b0c0ebcbba3b8a565e1f975e21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskCollectionSubscription$variables = {
  routineIds: ReadonlyArray<string>;
  taskIds: ReadonlyArray<string>;
};
export type WidgetTaskCollectionSubscription$data = {
  readonly routineTaskExecutionChanged: {
    readonly id: string;
    readonly taskSection: {
      readonly id: string;
      readonly inProgressTaskExecution: {
        readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskMultipleRenderTask_taskExecution">;
      } | null;
    };
  } | null;
};
export type WidgetTaskCollectionSubscription = {
  response: WidgetTaskCollectionSubscription$data;
  variables: WidgetTaskCollectionSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routineIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "taskIds"
},
v2 = [
  {
    "kind": "Variable",
    "name": "routineIds",
    "variableName": "routineIds"
  },
  {
    "kind": "Variable",
    "name": "taskIds",
    "variableName": "taskIds"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetTaskCollectionSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "routineTaskExecutionChanged",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "taskSection",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "inProgressTaskExecution",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "WidgetTaskMultipleRenderTask_taskExecution"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WidgetTaskCollectionSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "routineTaskExecutionChanged",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "taskSection",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "inProgressTaskExecution",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isTaskExecution"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineOccasion",
                    "kind": "LinkedField",
                    "name": "routineOccasion",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endAt",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "checkValue",
                        "storageKey": null
                      }
                    ],
                    "type": "TaskExecutionCheck",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "numberValue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedNumberValue",
                        "storageKey": null
                      }
                    ],
                    "type": "TaskExecutionNumber",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "textValue",
                        "storageKey": null
                      }
                    ],
                    "type": "TaskExecutionText",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5e400cb4ceebe9e22478e4f2485f1266",
    "id": null,
    "metadata": {},
    "name": "WidgetTaskCollectionSubscription",
    "operationKind": "subscription",
    "text": "subscription WidgetTaskCollectionSubscription(\n  $taskIds: [ID!]!\n  $routineIds: [ID!]!\n) {\n  routineTaskExecutionChanged(routineIds: $routineIds, taskIds: $taskIds) {\n    __typename\n    id\n    taskSection {\n      __typename\n      id\n      inProgressTaskExecution {\n        __typename\n        ...WidgetTaskMultipleRenderTask_taskExecution\n        id\n      }\n    }\n  }\n}\n\nfragment WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck on TaskExecutionCheck {\n  checkValue\n}\n\nfragment WidgetTaskMultipleRenderTaskContent_taskExecution on TaskExecution {\n  __isTaskExecution: __typename\n  ... on TaskExecutionCheck {\n    __typename\n    ...WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck\n  }\n  ... on TaskExecutionNumber {\n    __typename\n    ...WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber\n  }\n  ... on TaskExecutionText {\n    __typename\n    ...WidgetTaskMultipleRenderTaskText_taskExecutionText\n  }\n}\n\nfragment WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber on TaskExecutionNumber {\n  numberValue\n  formattedNumberValue\n}\n\nfragment WidgetTaskMultipleRenderTaskText_taskExecutionText on TaskExecutionText {\n  textValue\n}\n\nfragment WidgetTaskMultipleRenderTask_taskExecution on TaskExecution {\n  __isTaskExecution: __typename\n  ...WidgetTaskMultipleRenderTaskContent_taskExecution\n  routineOccasion {\n    endAt\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe9d1cf7e729aeb34c1a88d1f9576e22";

export default node;
